/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Thai (Thailand)
export default {
  'fabric.linkPicker.button.cancel': 'ยกเลิก',
  'fabric.linkPicker.button.insert': 'แทรก',
  'fabric.linkPicker.button.save': 'บันทึก',
  'fabric.linkPicker.clearLink': 'ล้าง',
  'fabric.linkPicker.clearLinkText': 'ล้างข้อความ',
  'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {ไม่พบผลลัพธ์} other {พบผลลัพธ์ {count,number} รายการ}}',
  'fabric.linkPicker.linkAriaLabel': 'พิมพ์หรือวางลิงก์ในช่อง',
  'fabric.linkPicker.linkInvalid': 'ป้อน URL ที่ถูกต้อง',
  'fabric.linkPicker.linkLabel': 'ลิงก์',
  'fabric.linkPicker.linkPlaceholder': 'วางลิงก์',
  'fabric.linkPicker.linkTextAriaLabel': 'ข้อความแสดงลิงก์',
  'fabric.linkPicker.linkTextLabel': 'ข้อความที่แสดง (ตัวเลือก)',
  'fabric.linkPicker.linkTextPlaceholder': 'ข้อความที่จะแสดง',
  'fabric.linkPicker.listTitle.recentlyViewed': 'ดูล่าสุด',
  'fabric.linkPicker.listTitle.results': 'ผลลัพธ์',
  'fabric.linkPicker.search.error.description': 'รีเฟรชหน้าข้อมูล หรือติดต่อฝ่าย <a>สนับสนุน Atlassian</a> หากยังคงมีปัญหานี้เกิดขึ้น',
  'fabric.linkPicker.search.error.heading': 'เรากำลังมีปัญหาในการโหลดข้อมูล',
  'fabric.linkPicker.search.linkAriaLabel': 'ข้อเสนอแนะจะปรากฏด้านล่างเมื่อคุณพิมพ์ลงในช่อง',
  'fabric.linkPicker.search.linkLabel': 'ค้นหาหรือวางลิงก์',
  'fabric.linkPicker.search.linkPlaceholder': 'ค้นหาลิงก์ล่าสุดหรือวางลิงก์ใหม่',
  'fabric.linkPicker.search.noResults.description': 'ลองอีกครั้งด้วยคำอื่น',
  'fabric.linkPicker.search.noResults.heading': 'เราไม่พบรายการใด ๆ ที่ตรงกับการค้นหาของคุณ',
  'fabric.linkPicker.status.submitting': 'กำลังส่ง',
  'fabric.linkPicker.time.message.updated': 'อัปเดตแล้วเมื่อ {time}',
  'fabric.linkPicker.time.message.viewed': 'ดูเมื่อ {time}',
  'fabric.linkPicker.unhandledError.description': 'ลองโหลดหน้าข้อมูลใหม่อีกครั้ง',
  'fabric.linkPicker.unhandledError.heading': 'เกิดข้อผิดพลาดบางอย่าง!'
};